<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2020 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2020</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">29 28 27 26 25 24 23 22 21 20    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-62353-5 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-73756-0 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-62367-2 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226623672.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226623672.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Tugendhaft, Aaron, author.</p>
<p class="cip">Title: The idols of ISIS : from Assyria to the internet / Aaron Tugendhaft.</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2020. | Includes bibliographical references.</p>
<p class="cip">Identifiers: LCCN 2020007574 | ISBN 9780226623535 (cloth) | ISBN 9780226737560 (paperback) | ISBN 9780226623672 (ebook)</p>
<p class="cip">Subjects: LCSH: <span class="ccust1">Matḥaf al-Mawṣil</span>. | IS (Organization) | Iconoclasm—Middle East. | Cultural property—Destruction and pillage—Middle East. | Idols and images—Middle East. | Motion pictures in propaganda. | Mass media and propaganda. | Islamic fundamentalism—Middle East.</p>
<p class="cip">Classification: LCC N9103 .T84 2020 | DDC 700/.4820218—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2020007574" target="_blank">https://lccn.loc.gov/2020007574</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-tugendhaft-0004.vue?5f98675e